import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { StorageService } from '../../managers/storage.service';
import { Config } from '../config';


@Injectable({
  providedIn: 'root'
})
export class DepartmentsService  extends Config {

  constructor(private httpClient: HttpClient,  private storageService: StorageService) {
    super();
  }

  public getDepartments(): Observable<any> {
    let url = "departments_get";

    return this.httpClient.get(this.BASE_URL + url, this.storageService.getHeaders());
  }

}
